/**
*
* Getters ProductFile Orange
*
*/

import {
    GET_CURRENT_STEP,
    GET_OPTION_STATE
} from './types/gettersTypes'

const getters = {
    [GET_CURRENT_STEP]: state => state.currentStep,
    [GET_OPTION_STATE]: state => state.optionState
}

export default getters
